// document.addEventListener("DOMContentLoaded", function() {
    let navAll = document.querySelectorAll('.nav-level__item');
    let infosBlockAll = document.querySelectorAll('.infos-block');

    window.choiceYourCategory = function(e){
        e = e || window.event;
        let target = e.target;

        let sectionName = target.getAttribute('data-id');

        for(let i =0;i < navAll.length;i++){
            navAll[i].classList.remove('active');
        }

        for(let i =0;i < infosBlockAll.length;i++){
            infosBlockAll[i].classList.remove('show-block');
        }

        target.classList.add('active');

        document.querySelector('#' + sectionName).classList.add('show-block');
    }

    const sizes = {
        "tabUnderwear":[
            {"weightUnderwear":"52,5-57,5", "sizeUK":"(S)", "sizeFR":"T2","sizeUnderwear":"1,57-1,62"},
            {"weightUnderwear":"52,5-57,5", "sizeUK":"(S)", "sizeFR":"T2","sizeUnderwear":"1,62-1,67"},
            {"weightUnderwear":"52,5-57,5", "sizeUK":"(S)", "sizeFR":"T2","sizeUnderwear":"1,67-1,72"},
            {"weightUnderwear":"52,5-57,5", "sizeUK":"(S)", "sizeFR":"T2","sizeUnderwear":"1,72-1,77"},
            {"weightUnderwear":"52,5-57,5", "sizeUK":"(S)", "sizeFR":"T2","sizeUnderwear":"1,77-1,82"},
            {"weightUnderwear":"57,5-62,5", "sizeUK":"(S)", "sizeFR":"T2","sizeUnderwear":"1,57-1,62"},
            {"weightUnderwear":"57,5-62,5", "sizeUK":"(S)", "sizeFR":"T2","sizeUnderwear":"1,62-1,67"},
            {"weightUnderwear":"57,5-62,5", "sizeUK":"(S)", "sizeFR":"T2","sizeUnderwear":"1,67-1,72"},
            {"weightUnderwear":"57,5-62,5", "sizeUK":"(S)", "sizeFR":"T2","sizeUnderwear":"1,72-1,77"},
            {"weightUnderwear":"57,5-62,5", "sizeUK":"(S)", "sizeFR":"T2","sizeUnderwear":"1,77-1,82"},
            {"weightUnderwear":"57,5-62,5", "sizeUK":"(S)", "sizeFR":"T2","sizeUnderwear":"1,82-1,87"},
            {"weightUnderwear":"62,5-67,5", "sizeUK":"(M)", "sizeFR":"T3","sizeUnderwear":"1,57-1,62"},
            {"weightUnderwear":"62,5-67,5", "sizeUK":"(M)", "sizeFR":"T3","sizeUnderwear":"1,62-1,67"},
            {"weightUnderwear":"62,5-67,5", "sizeUK":"(M)", "sizeFR":"T3","sizeUnderwear":"1,67-1,72"},
            {"weightUnderwear":"62,5-67,5", "sizeUK":"(M)", "sizeFR":"T3","sizeUnderwear":"1,72-1,77"},
            {"weightUnderwear":"62,5-67,5", "sizeUK":"(M)", "sizeFR":"T3","sizeUnderwear":"1,77-1,82"},
            {"weightUnderwear":"62,5-67,5", "sizeUK":"(S)", "sizeFR":"T2","sizeUnderwear":"1,82-1,87"},
            {"weightUnderwear":"62,5-67,5", "sizeUK":"(S)", "sizeFR":"T2","sizeUnderwear":"1,87-1,92"},
            {"weightUnderwear":"67,5-72,5", "sizeUK":"(M)", "sizeFR":"T3","sizeUnderwear":"1,57-1,62"},
            {"weightUnderwear":"67,5-72,5", "sizeUK":"(M)", "sizeFR":"T3","sizeUnderwear":"1,62-1,67"},
            {"weightUnderwear":"67,5-72,5", "sizeUK":"(M)", "sizeFR":"T3","sizeUnderwear":"1,67-1,72"},
            {"weightUnderwear":"67,5-72,5", "sizeUK":"(M)", "sizeFR":"T3","sizeUnderwear":"1,72-1,77"},
            {"weightUnderwear":"67,5-72,5", "sizeUK":"(M)", "sizeFR":"T3","sizeUnderwear":"1,77-1,82"},
            {"weightUnderwear":"67,5-72,5", "sizeUK":"(M)", "sizeFR":"T3","sizeUnderwear":"1,82-1,87"},
            {"weightUnderwear":"67,5-72,5", "sizeUK":"(M)", "sizeFR":"T3","sizeUnderwear":"1,87-1,92"},
            {"weightUnderwear":"67,5-72,5", "sizeUK":"(M)", "sizeFR":"T3","sizeUnderwear":"1,92-1,97"},
            {"weightUnderwear":"72,5-77,5", "sizeUK":"(L)", "sizeFR":"T4","sizeUnderwear":"1,57-1,62"},
            {"weightUnderwear":"72,5-77,5", "sizeUK":"(L)", "sizeFR":"T4","sizeUnderwear":"1,62-1,67"},
            {"weightUnderwear":"72,5-77,5", "sizeUK":"(L)", "sizeFR":"T4","sizeUnderwear":"1,67-1,72"},
            {"weightUnderwear":"72,5-77,5", "sizeUK":"(L)", "sizeFR":"T4","sizeUnderwear":"1,72-1,77"},
            {"weightUnderwear":"72,5-77,5", "sizeUK":"(L)", "sizeFR":"T4","sizeUnderwear":"1,77-1,82"},
            {"weightUnderwear":"72,5-77,5", "sizeUK":"(L)", "sizeFR":"T4","sizeUnderwear":"1,82-1,87"},
            {"weightUnderwear":"72,5-77,5", "sizeUK":"(L)", "sizeFR":"T4","sizeUnderwear":"1,87-1,92"},
            {"weightUnderwear":"72,5-77,5", "sizeUK":"(L)", "sizeFR":"T4","sizeUnderwear":"1,92-1,97"},
            {"weightUnderwear":"77,5-82,5", "sizeUK":"(L)", "sizeFR":"T4","sizeUnderwear":"1,57-1,62"},
            {"weightUnderwear":"77,5-82,5", "sizeUK":"(L)", "sizeFR":"T4","sizeUnderwear":"1,62-1,67"},
            {"weightUnderwear":"77,5-82,5", "sizeUK":"(L)", "sizeFR":"T4","sizeUnderwear":"1,67-1,72"},
            {"weightUnderwear":"77,5-82,5", "sizeUK":"(L)", "sizeFR":"T4","sizeUnderwear":"1,72-1,77"},
            {"weightUnderwear":"77,5-82,5", "sizeUK":"(L)", "sizeFR":"T4","sizeUnderwear":"1,77-1,82"},
            {"weightUnderwear":"77,5-82,5", "sizeUK":"(L)", "sizeFR":"T4","sizeUnderwear":"1,82-1,87"},
            {"weightUnderwear":"77,5-82,5", "sizeUK":"(L)", "sizeFR":"T4","sizeUnderwear":"1,87-1,92"},
            {"weightUnderwear":"77,5-82,5", "sizeUK":"(L)", "sizeFR":"T4","sizeUnderwear":"1,92-1,97"},
            {"weightUnderwear":"82,5-87,5", "sizeUK":"(XL)", "sizeFR":"T5","sizeUnderwear":"1,57-1,62"},
            {"weightUnderwear":"82,5-87,5", "sizeUK":"(XL)", "sizeFR":"T5","sizeUnderwear":"1,62-1,67"},
            {"weightUnderwear":"82,5-87,5", "sizeUK":"(XL)", "sizeFR":"T5","sizeUnderwear":"1,67-1,72"},
            {"weightUnderwear":"82,5-87,5", "sizeUK":"(XL)", "sizeFR":"T5","sizeUnderwear":"1,72-1,77"},
            {"weightUnderwear":"82,5-87,5", "sizeUK":"(XL)", "sizeFR":"T5","sizeUnderwear":"1,77-1,82"},
            {"weightUnderwear":"82,5-87,5", "sizeUK":"(L)", "sizeFR":"T4","sizeUnderwear":"1,82-1,87"},
            {"weightUnderwear":"82,5-87,5", "sizeUK":"(L)", "sizeFR":"T4","sizeUnderwear":"1,87-1,92"},
            {"weightUnderwear":"82,5-87,5", "sizeUK":"(L)", "sizeFR":"T4","sizeUnderwear":"1,92-1,97"},
            {"weightUnderwear":"87,5-92,5", "sizeUK":"(XL)", "sizeFR":"T5","sizeUnderwear":"1,57-1,62"},
            {"weightUnderwear":"87,5-92,5", "sizeUK":"(XL)", "sizeFR":"T5","sizeUnderwear":"1,62-1,67"},
            {"weightUnderwear":"87,5-92,5", "sizeUK":"(XL)", "sizeFR":"T5","sizeUnderwear":"1,67-1,72"},
            {"weightUnderwear":"87,5-92,5", "sizeUK":"(XL)", "sizeFR":"T5","sizeUnderwear":"1,72-1,77"},
            {"weightUnderwear":"87,5-92,5", "sizeUK":"(XL)", "sizeFR":"T5","sizeUnderwear":"1,77-1,82"},
            {"weightUnderwear":"87,5-92,5", "sizeUK":"(XL)", "sizeFR":"T5","sizeUnderwear":"1,82-1,87"},
            {"weightUnderwear":"87,5-92,5", "sizeUK":"(XL)", "sizeFR":"T5","sizeUnderwear":"1,87-1,92"},
            {"weightUnderwear":"87,5-92,5", "sizeUK":"(XL)", "sizeFR":"T5","sizeUnderwear":"1,92-1,97"},
            {"weightUnderwear":"92,5-97,5", "sizeUK":"(XXL)", "sizeFR":"T6","sizeUnderwear":"1,57-1,62"},
            {"weightUnderwear":"92,5-97,5", "sizeUK":"(XL)", "sizeFR":"T5","sizeUnderwear":"1,62-1,67"},
            {"weightUnderwear":"92,5-97,5", "sizeUK":"(XL)", "sizeFR":"T5","sizeUnderwear":"1,67-1,72"},
            {"weightUnderwear":"92,5-97,5", "sizeUK":"(XL)", "sizeFR":"T5","sizeUnderwear":"1,72-1,77"},
            {"weightUnderwear":"92,5-97,5", "sizeUK":"(XL)", "sizeFR":"T5","sizeUnderwear":"1,77-1,82"},
            {"weightUnderwear":"92,5-97,5", "sizeUK":"(XL)", "sizeFR":"T5","sizeUnderwear":"1,82-1,87"},
            {"weightUnderwear":"92,5-97,5", "sizeUK":"(XL)", "sizeFR":"T5","sizeUnderwear":"1,87-1,92"},
            {"weightUnderwear":"92,5-97,5", "sizeUK":"(XL)", "sizeFR":"T5","sizeUnderwear":"1,92-1,97"},
            {"weightUnderwear":"97,5-102,5", "sizeUK":"(XXL)", "sizeFR":"T6","sizeUnderwear":"1,57-1,62"},
            {"weightUnderwear":"97,5-102,5", "sizeUK":"(XXL)", "sizeFR":"T6","sizeUnderwear":"1,62-1,67"},
            {"weightUnderwear":"97,5-102,5", "sizeUK":"(XXL)", "sizeFR":"T6","sizeUnderwear":"1,67-1,72"},
            {"weightUnderwear":"97,5-102,5", "sizeUK":"(XXL)", "sizeFR":"T6","sizeUnderwear":"1,72-1,77"},
            {"weightUnderwear":"97,5-102,5", "sizeUK":"(XL)", "sizeFR":"T5","sizeUnderwear":"1,77-1,82"},
            {"weightUnderwear":"97,5-102,5", "sizeUK":"(XL)", "sizeFR":"T5","sizeUnderwear":"1,82-1,87"},
            {"weightUnderwear":"97,5-102,5", "sizeUK":"(XL)", "sizeFR":"T5","sizeUnderwear":"1,87-1,92"},
            {"weightUnderwear":"97,5-102,5", "sizeUK":"(XL)", "sizeFR":"T5","sizeUnderwear":"1,92-1,97"},
            {"weightUnderwear":"102,5-107,5", "sizeUK":"(XXXL)", "sizeFR":"T7","sizeUnderwear":"1,57-1,62"},
            {"weightUnderwear":"102,5-107,5", "sizeUK":"(XXXL)", "sizeFR":"T7","sizeUnderwear":"1,62-1,67"},
            {"weightUnderwear":"102,5-107,5", "sizeUK":"(XXL)", "sizeFR":"T6","sizeUnderwear":"1,67-1,72"},
            {"weightUnderwear":"102,5-107,5", "sizeUK":"(XXL)", "sizeFR":"T6","sizeUnderwear":"1,72-1,77"},
            {"weightUnderwear":"102,5-107,5", "sizeUK":"(XXL)", "sizeFR":"T6","sizeUnderwear":"1,77-1,82"},
            {"weightUnderwear":"102,5-107,5", "sizeUK":"(XXL)", "sizeFR":"T6","sizeUnderwear":"1,82-1,87"},
            {"weightUnderwear":"102,5-107,5", "sizeUK":"(XXL)", "sizeFR":"T6","sizeUnderwear":"1,87-1,92"},
            {"weightUnderwear":"102,5-107,5", "sizeUK":"(XXL)", "sizeFR":"T6","sizeUnderwear":"1,92-1,97"},
            {"weightUnderwear":"107,5-112,5", "sizeUK":"(XXXL)", "sizeFR":"T7","sizeUnderwear":"1,57-1,62"},
            {"weightUnderwear":"107,5-112,5", "sizeUK":"(XXXL)", "sizeFR":"T7","sizeUnderwear":"1,62-1,67"},
            {"weightUnderwear":"107,5-112,5", "sizeUK":"(XXXL)", "sizeFR":"T7","sizeUnderwear":"1,67-1,72"},
            {"weightUnderwear":"107,5-112,5", "sizeUK":"(XXL)", "sizeFR":"T6","sizeUnderwear":"1,72-1,77"},
            {"weightUnderwear":"107,5-112,5", "sizeUK":"(XXL)", "sizeFR":"T6","sizeUnderwear":"1,77-1,82"},
            {"weightUnderwear":"107,5-112,5", "sizeUK":"(XXL)", "sizeFR":"T6","sizeUnderwear":"1,82-1,87"},
            {"weightUnderwear":"107,5-112,5", "sizeUK":"(XXL)", "sizeFR":"T6","sizeUnderwear":"1,87-1,92"},
            {"weightUnderwear":"107,5-112,5", "sizeUK":"(XXL)", "sizeFR":"T6","sizeUnderwear":"1,92-1,97"},
            {"weightUnderwear":"112,5-117,5", "sizeUK":"(XXXL)", "sizeFR":"T7","sizeUnderwear":"1,57-1,62"},
            {"weightUnderwear":"112,5-117,5", "sizeUK":"(XXXL)", "sizeFR":"T7","sizeUnderwear":"1,62-1,67"},
            {"weightUnderwear":"112,5-117,5", "sizeUK":"(XXXL)", "sizeFR":"T7","sizeUnderwear":"1,67-1,72"},
            {"weightUnderwear":"112,5-117,5", "sizeUK":"(XXXL)", "sizeFR":"T7","sizeUnderwear":"1,72-1,77"},
            {"weightUnderwear":"112,5-117,5", "sizeUK":"(XXXL)", "sizeFR":"T7","sizeUnderwear":"1,77-1,82"},
            {"weightUnderwear":"112,5-117,5", "sizeUK":"(XXL)", "sizeFR":"T6","sizeUnderwear":"1,82-1,87"},
            {"weightUnderwear":"112,5-117,5", "sizeUK":"(XXL)", "sizeFR":"T6","sizeUnderwear":"1,87-1,92"},
            {"weightUnderwear":"112,5-117,5", "sizeUK":"(XXL)", "sizeFR":"T6","sizeUnderwear":"1,92-1,97"},
            {"weightUnderwear":"117,5-122,5", "sizeUK":"(XXXL)", "sizeFR":"T7","sizeUnderwear":"1,57-1,62"},
            {"weightUnderwear":"117,5-122,5", "sizeUK":"(XXXL)", "sizeFR":"T7","sizeUnderwear":"1,62-1,67"},
            {"weightUnderwear":"117,5-122,5", "sizeUK":"(XXXL)", "sizeFR":"T7","sizeUnderwear":"1,67-1,72"},
            {"weightUnderwear":"117,5-122,5", "sizeUK":"(XXXL)", "sizeFR":"T7","sizeUnderwear":"1,72-1,77"},
            {"weightUnderwear":"117,5-122,5", "sizeUK":"(XXXL)", "sizeFR":"T7","sizeUnderwear":"1,77-1,82"},
            {"weightUnderwear":"117,5-122,5", "sizeUK":"(XXL)", "sizeFR":"T6","sizeUnderwear":"1,82-1,87"},
            {"weightUnderwear":"117,5-122,5", "sizeUK":"(XXL)", "sizeFR":"T6","sizeUnderwear":"1,87-1,92"},
            {"weightUnderwear":"117,5-122,5", "sizeUK":"(XXL)", "sizeFR":"T6","sizeUnderwear":"1,92-1,97"},
            {"weightUnderwear":"122,5-127,5", "sizeUK":"(XXXL)", "sizeFR":"T7","sizeUnderwear":"1,62-1,67"},
            {"weightUnderwear":"122,5-127,5", "sizeUK":"(XXXL)", "sizeFR":"T7","sizeUnderwear":"1,67-1,72"},
            {"weightUnderwear":"122,5-127,5", "sizeUK":"(XXXL)", "sizeFR":"T7","sizeUnderwear":"1,72-1,77"},
            {"weightUnderwear":"122,5-127,5", "sizeUK":"(XXXL)", "sizeFR":"T7","sizeUnderwear":"1,77-1,82"},
            {"weightUnderwear":"122,5-127,5", "sizeUK":"(XXXL)", "sizeFR":"T7","sizeUnderwear":"1,82-1,87"},
            {"weightUnderwear":"122,5-127,5", "sizeUK":"(XXXL)", "sizeFR":"T7","sizeUnderwear":"1,87-1,92"},
            {"weightUnderwear":"122,5-127,5", "sizeUK":"(XXL)", "sizeFR":"T6","sizeUnderwear":"1,92-1,97"},
            {"weightUnderwear":"127,5-132,5", "sizeUK":"(XXXL)", "sizeFR":"T7","sizeUnderwear":"1,77-1,82"},
            {"weightUnderwear":"127,5-132,5", "sizeUK":"(XXXL)", "sizeFR":"T7","sizeUnderwear":"1,82-1,87"},
            {"weightUnderwear":"127,5-132,5", "sizeUK":"(XXXL)", "sizeFR":"T7","sizeUnderwear":"1,87-1,92"},
            {"weightUnderwear":"127,5-132,5", "sizeUK":"(XXXL)", "sizeFR":"T7","sizeUnderwear":"1,92-1,97"}
        ]
    };

    const empty = '';

    let resultsSizeUnderwear = document.querySelector('#results-underwear');

    let weightUnderwear = document.querySelector('#weight-underwear');
    let sizeUnderwear = document.querySelector('#size-underwear');

    window.createOption = function(value,domElem){
        let tmp = document.createElement('option');
        tmp.setAttribute('value', value);
        tmp.text = value;
        domElem.appendChild(tmp);
    }

    window.resetOption = function(domElem){
       var i, L = domElem.options.length - 1;
       for(i = L; i >= 0; i--) {
          domElem.remove(i);
       }
    }

    window.results = function(size,cup,domElem){
        domElem.textContent = size + " " + cup;
    }

    window.resetResults = function(domElem){
        domElem.textContent = "---";
    }

    sizeUnderwear.addEventListener('change', function () {
        let currentSize = this.value;
        let currentWeight = weightUnderwear.value;
        let resultSizeUK, resultSizeFR;

        for(let i=0; i < sizes.tabUnderwear.length; i++){
            if(currentSize !== "undefined" && sizes.tabUnderwear[i].sizeUnderwear == currentSize && sizes.tabUnderwear[i].weightUnderwear == currentWeight){
                resultSizeUK = sizes.tabUnderwear[i].sizeUK;
                resultSizeFR = sizes.tabUnderwear[i].sizeFR;
            } else{
                resetResults(resultsSizeUnderwear);
            }
        }

        if(resultSizeFR !== "undefined" && resultSizeUK !== "undefined"){
            results(resultSizeFR,resultSizeUK,resultsSizeUnderwear);
        }
    });

    weightUnderwear.addEventListener('change', function () {
        let currentWeight = this.value;
        let resultSizeUK, resultSizeFR;
        resetOption(sizeUnderwear);

        for(let i=0; i < sizes.tabUnderwear.length; i++){
            if(currentWeight !== "undefined" && sizes.tabUnderwear[i].weightUnderwear == currentWeight){
                createOption(sizes.tabUnderwear[i].sizeUnderwear, sizeUnderwear);
                let currentSize = sizeUnderwear.value;
                if(sizes.tabUnderwear[i].sizeUnderwear == currentSize){
                    resultSizeUK = sizes.tabUnderwear[i].sizeUK;
                    resultSizeFR = sizes.tabUnderwear[i].sizeFR;
                }
            }
        }

        if(resultSizeFR !== undefined && resultSizeUK !== undefined){
            results(resultSizeFR,resultSizeUK,resultsSizeUnderwear);
        } else{
            resetResults(resultsSizeUnderwear);
        }
    });

    let slideUp = (target, duration=500) => {
        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionDuration = duration + 'ms';
        target.style.boxSizing = 'border-box';
        target.style.height = target.offsetHeight + 'px';
        target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        window.setTimeout( () => {
          target.style.display = 'none';
          target.style.removeProperty('height');
          target.style.removeProperty('padding-top');
          target.style.removeProperty('padding-bottom');
          target.style.removeProperty('margin-top');
          target.style.removeProperty('margin-bottom');
          target.style.removeProperty('overflow');
          target.style.removeProperty('transition-duration');
          target.style.removeProperty('transition-property');
        }, duration);
      }

      let slideDown = (target, duration=500) => {
        target.style.removeProperty('display');
        let display = window.getComputedStyle(target).display;

        if (display === 'none')
          display = 'block';

        target.style.display = display;
        let height = target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        target.offsetHeight;
        target.style.boxSizing = 'border-box';
        target.style.transitionProperty = "height, margin, padding";
        target.style.transitionDuration = duration + 'ms';
        target.style.height = height + 'px';
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        window.setTimeout( () => {
          target.style.removeProperty('height');
          target.style.removeProperty('overflow');
          target.style.removeProperty('transition-duration');
          target.style.removeProperty('transition-property');
        }, duration);
      }
       let slideToggle = (target, duration = 500) => {
        target.parentNode.querySelector('.chevron-right').classList.toggle('rotate');
        if (window.getComputedStyle(target).display === 'none') {
          return slideDown(target, duration);

        } else {
          return slideUp(target, duration);
        }
      }

    let speedAnimation = 400;

    let slideBtnClick = (id, sl, targetId) => document.getElementById(id).addEventListener('click', () => sl(targetId, speedAnimation));

    slideBtnClick('slideUnderwear', slideToggle, showTabUnderwear);
    slideBtnClick('slideSocks', slideToggle, showTabSocks);
    slideBtnClick('slideSport', slideToggle, showTabSport);
    slideBtnClick('slidePyjamas', slideToggle, showTabPyjamas);

    ReadMore.init();
// });
